const initialState = {}

const appendedList = (state, params) => {
  return [params, ...state.sentNotifications]
}

const pushNotifications = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'PUSH_NOTIFICATIONS.INIT':
      return {...state, ...payload}
    case 'PUSH_NOTIFICATIONS.ADD':
      return {...state, sentNotifications: appendedList(state, payload)}
    case 'PUSH_NOTIFICATIONS.SETPAGE':
      return {...state, page: payload}
    case 'PUSH_NOTIFICATIONS.PAGESIZE':
      return {...state, perPage: payload, page: 1}
    case 'PUSH_NOTIFICATIONS.RECEIVED':
      return {...state, sentNotifications: payload.notifications, total: payload.total}
    default:
      return state
  }
}

export default pushNotifications
